@if(path() !== null) {
  @if(isPriority()) {
    <img
      [alt]="segment()"
      [height]="imageSize()"
      [ngSrc]="path()"
      [width]="imageSize()"
      [attr.fetchpriority]="'high'"
      [priority]="true"
      class="align-middle mr-3"
    >
  }
  @else {
    <img
      [alt]="segment()"
      [height]="imageSize()"
      [ngSrc]="path()"
      [width]="imageSize()"
      [attr.fetchpriority]="'auto'"
      [loading]="'lazy'"
      class="align-middle mr-3"
    >
  }
}
